import * as React from 'react';
import { Root } from '../../node_modules/@radix-ui/react-label/dist/index.esm.js';
import { cva } from '../../node_modules/class-variance-authority/dist/index.esm.js';
import { cn } from '../../lib/utils.esm.js';

const labelVariants = cva("m-0 text-md font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 peer-checked:font-semibold", {
  variants: {
    variant: {
      default: "text-shark-900 peer-checked:font-semibold"
    }
  }
});
const Label = /*#__PURE__*/React.forwardRef(({
  className,
  ...props
}, ref) => (/*#__PURE__*/React.createElement(Root, {
  ref: ref,
  className: cn(labelVariants(), className),
  ...props
})));
Label.displayName = Root.displayName;

export { Label };
//# sourceMappingURL=label.esm.js.map
